import { render, staticRenderFns } from "./solution.vue?vue&type=template&id=2a9d4d2f&"
import script from "./solution.vue?vue&type=script&lang=js&"
export * from "./solution.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports